import { Redirect, Route, Switch } from "react-router-dom";
import CompanyLayout from "../layouts/dashboardEmpresa/companyLayout";
import ChangePassword from "../views/auth/changePassword";
import CompanyHome from "../views/company";
import BusinessCards from "../views/company/businessCards";
import AssociatesAdd from "../views/company/businessCards/add";
import Categories from "../views/company/categories";
import CategoriesAdd from "../views/company/categories/add";
import CategoriesUpdate from "../views/company/categories/update";
import Coupons from "../views/company/coupons";
import CouponsAdd from "../views/company/coupons/add";
import Products from "../views/company/products";
import ProductCreate from "../views/company/products/products/ProductCreate";
import ProductUpdate from "../views/company/products/update";
import CompanyProfile from "../views/company/profile";
import Merchants from "../views/website/merchants";
import BusinessCard from "../views/website/merchants/businessCard";
import MerchantMenu from "../views/website/merchants/menu";
import MerchantMenuProducts from "../views/website/merchants/menuProducts";
import MerchantProfile from "../views/website/merchants/profile";
import MerchantSelect from "../views/website/merchants/select";

import AppRoute from "./AppRoute";
import Wallet from "../views/company/wallet";
import Pay from "../views/company/wallet/pay";
import DepositMethods from "../views/company/wallet/deposit/methods";
import Events from "../views/company/events";
import EventsAdd from "../views/company/events/add";
import EventsUpdate from "../views/company/events/update";

import MyBankAccounts from "../views/company/finances/banks";
import AddBankAccount from "../views/company/finances/banks/add";
import Orders from "../views/company/orders";
import Sponsors from "../views/company/events/sponsors";
import SponsorAdd from "../views/company/events/sponsors/add";
import Tourism from "../views/company/tourism";
import TourismAdd from "../views/company/tourism/add";
import TourismUpdate from "../views/company/tourism/update";
import CompanyReservations from "../views/company/reservations";
import Ticket from "../views/client/events/ticket";
import OrderDetails from "../views/company/orders/details";
import Artemis from "../views/taxi/Artemis";
import MamaAzul from "../views/website/allies/mamaazul";
import Reviews from "../views/company/reviews";
import Subscriptions from "../views/company/subscriptions";
import SubscriptionAdd from "../views/company/subscriptions/add";
import Cashless from "../views/company/cashless";
import CashlessEconomyCreate from "../views/company/cashless/economies/create";
import CashlessEconomyDetails from "../views/company/cashless/economies/details";


import Eventos from '../views/website/events';
import EventsDetails from "../views/website/events/detail";
import EventsTickets from "../views/website/events";

import EventsReview from "../views/website/events/review";
import EventsReviewFeriaTurismo from "../views/website/events/feriaTurismo";
import EventsGastromedia from "../views/website/events/gastromedia";
import GastromediaAlly from "../views/website/allies/gastromedia";
import { HomeLayout } from "../layouts/Website/home/HomeLayout";
import Attributes from "../views/company/products/attributes";
import AttributesCreate from "../views/company/products/attributes/create";
import AttributesValues from "../views/company/products/attributes/values";
import AttributesValuesCreate from "../views/company/products/attributes/values/create";
import AttributesValuesUpdate from "../views/company/products/attributes/values/update";
import ProductEdit from "../views/company/products/products/ProductEdit";
import ModifierGroups from "../views/company/products/modifierGroups";
import ModifierGroupsCreate from "../views/company/products/modifierGroups/create";
import ModifierGroupOptions from "../views/company/products/modifierGroups/options";
import ModifierOptionCreate from "../views/company/products/modifierGroups/options/create";
import ModifierOptionUpdate from "../views/company/products/modifierGroups/options/update";
import Plans from "../views/company/subscriptions/plans/Plans";
import PlanCreate from "../views/company/subscriptions/plans/PlanCreate";
import PlanEdit from "../views/company/subscriptions/plans/PlanEdit";
import PlanDetail from "../views/company/subscriptions/plans/PlanDetail";
import SubscriptionEnroll from "../views/company/subscriptions/subscriptions/SubscriptionEnroll";
import SubscriptionsIndex from "../views/company/subscriptions";
import AssetsManager from "../views/company/assets/AssetsManager";
import ResourceLinker from "../views/company/assets/ResourceLinker";
import ProductCreateV2 from "../views/company/products/products/ProductCreateV2";
import ProductWizard from "../views/company/products/products/ProductWizard";
import ProductEditV2 from "../views/company/products/products/ProductEditV2";
import Employees from "../views/company/employees/Employees";
import MerchantReservationsPage from "../views/company/bookings/ReservationsPage";
import MerchantBankAccounts from "../views/company/finances/MerchantBankAccounts";
import EventTabs from "../views/company/events/event";



export default function CompanyNavigation()
{
    return(
        <Switch>
            <AppRoute exact path='/' layout={CompanyLayout} component={CompanyHome} />

            <AppRoute exact path='/artemis' layout={CompanyLayout} component={Artemis} />
            <AppRoute exact path='/mamaazul' layout={CompanyLayout} component={MamaAzul} />

            <AppRoute exact path='/profile' layout={CompanyLayout} component={CompanyProfile} />
            <AppRoute exact path='/reviews' layout={CompanyLayout} component={Reviews} />

            <AppRoute exact path='/security/changepassword' layout={CompanyLayout} component={ChangePassword} />

            

            <AppRoute exact path='/products' layout={CompanyLayout} component={Products} />
            {/*<AppRoute exact path='/products/create' layout={CompanyLayout} component={ProductCreate} />*/}
            <AppRoute exact path='/products/create' layout={CompanyLayout} component={ProductWizard} />
            <AppRoute exact path='/products/edit/:id' layout={CompanyLayout} component={ProductEditV2} />
            <AppRoute exact path='/products/update' layout={CompanyLayout} component={ProductUpdate} />

            <AppRoute exact path='/products/categories' layout={CompanyLayout} component={Categories} />
            <AppRoute exact path='/products/categories/add' layout={CompanyLayout} component={CategoriesAdd} />
            <AppRoute exact path='/products/categories/update' layout={CompanyLayout} component={CategoriesUpdate} />

            <AppRoute exact path='/products/attributes' layout={CompanyLayout} component={Attributes} />
            <AppRoute exact path='/products/attributes/create' layout={CompanyLayout} component={AttributesCreate} />
            <AppRoute exact path='/products/attributes/update/:id' layout={CompanyLayout} component={AttributesCreate} />
            <AppRoute exact path='/products/attributes/values/:attributeId' layout={CompanyLayout} component={AttributesValues} />
            <AppRoute exact path='/products/attributes/values/:attributeId/:attributeName/create' layout={CompanyLayout} component={AttributesValuesCreate} />
            <AppRoute exact path='/products/attributesValues/update/:attributeValueId' layout={CompanyLayout} component={AttributesValuesUpdate} />
            <AppRoute exact path='/products/modifiergroups' layout={CompanyLayout} component={ModifierGroups} />
            <AppRoute exact path='/products/modifiergroups/create' layout={CompanyLayout} component={ModifierGroupsCreate} />
            <AppRoute exact path='/products/modifiergroups/options/:modifierGroupId' layout={CompanyLayout} component={ModifierGroupOptions} />
            <AppRoute exact path='/products/modifiergroups/options/:modifierGroupId/create' layout={CompanyLayout} component={ModifierOptionCreate} />
            <AppRoute exact path='/products/modifiers/update/:modifierId' layout={CompanyLayout} component={ModifierOptionUpdate} />

            <AppRoute exact path='/orders' layout={CompanyLayout} component={Orders} />
            <AppRoute exact path='/orders/details/:code' layout={CompanyLayout} component={OrderDetails} />

            {/** SUBSCRIPTIONS */}
            <AppRoute exact path='/subscriptions' layout={CompanyLayout} component={SubscriptionsIndex} />
            <AppRoute exact path='/subscriptions/plans' layout={CompanyLayout} component={Plans} />
            <AppRoute exact path='/subscriptions/plans/create' layout={CompanyLayout} component={PlanCreate} />
            <AppRoute exact path='/subscriptions/plans/edit/:id' layout={CompanyLayout} component={PlanEdit} />
            <AppRoute exact path='/subscriptions/plans/detail/:id' layout={CompanyLayout} component={PlanDetail} />
            <AppRoute exact path='/subscriptions/enroll/:planId' layout={CompanyLayout} component={SubscriptionEnroll} />


            {/**Bookings */}
            <AppRoute exact path='/assets' layout={CompanyLayout} component={AssetsManager} />
            <AppRoute exact path='/assets/linker' layout={CompanyLayout} component={ResourceLinker} />


            <AppRoute exact path='/subscriptions/add' layout={CompanyLayout} component={SubscriptionAdd} />

            <AppRoute exact path='/coupons' layout={CompanyLayout} component={Coupons} />
            <AppRoute exact path='/coupons/add' layout={CompanyLayout} component={CouponsAdd} />


            <AppRoute exact path='/merchants' layout={CompanyLayout} component={Merchants} />
            <AppRoute exact path='/merchants/:uuid' layout={CompanyLayout} component={MerchantSelect} />
            <AppRoute exact path='/merchants/:uuid/menu' layout={CompanyLayout} component={MerchantMenu} />
            <AppRoute exact path='/merchants/:uuid/menu/:category_uuid' layout={CompanyLayout} component={MerchantMenuProducts} />
            <AppRoute exact path='/merchants/:uuid/profile' layout={CompanyLayout} component={MerchantProfile} />

            <AppRoute exact path='/employees' layout={CompanyLayout} component={Employees} />
            <AppRoute exact path='/associates/add' layout={CompanyLayout} component={AssociatesAdd} />

            <AppRoute exact path='/businesscard/:uuid' layout={CompanyLayout} component={BusinessCard} />

            <AppRoute exact path='/events' layout={CompanyLayout} component={Events} />
            <AppRoute exact path='/events/add' layout={CompanyLayout} component={EventsAdd} />
            <AppRoute exact path='/events/update/:id' layout={CompanyLayout} component={EventsUpdate} />

            <AppRoute exact path='/events/event/:id' layout={CompanyLayout} component={EventTabs} />

            <AppRoute exact path='/events/sponsors/:id' layout={CompanyLayout} component={Sponsors} />
            <AppRoute exact path='/events/sponsors/:id/add' layout={CompanyLayout} component={SponsorAdd} />
            <AppRoute exact path='/ticketing/:uuid' layout={CompanyLayout} component={Ticket} />


            {/**Para ver eventos de otros comerciantes */}
            <AppRoute exact path='/eventos' layout={CompanyLayout} component={Eventos} />
            <AppRoute exact path='/eventos/:id' layout={CompanyLayout} component={EventsDetails} />
            <AppRoute exact path='/eventos/:id/tickets' layout={CompanyLayout} component={EventsTickets} />
            <AppRoute exact path='/eventos/:id/review' layout={CompanyLayout} component={EventsReview} />
            <AppRoute exact path='/eventos/:id/review/feriaturismo' layout={HomeLayout} component={EventsReviewFeriaTurismo} />
            <AppRoute exact path='/eventos/:id/tastyfest/:producto_evento_uuid' layout={CompanyLayout} component={EventsGastromedia} />
            <AppRoute exact path='/gastromedia' layout={CompanyLayout} component={GastromediaAlly} />
            <AppRoute exact path='/tastyfest/:id' layout={CompanyLayout} component={EventsGastromedia} />


            {/**Reservations */}
            <AppRoute exact path='/reservations' layout={CompanyLayout} component={MerchantReservationsPage} />


            <AppRoute exact path='/tourism' layout={CompanyLayout} component={Tourism} />
            <AppRoute exact path='/tourism/add' layout={CompanyLayout} component={TourismAdd} />
            <AppRoute exact path='/tourism/update/:uuid' layout={CompanyLayout} component={TourismUpdate} />
            

            <AppRoute exact path='/finances/banks' layout={CompanyLayout} component={MerchantBankAccounts} />
            <AppRoute exact path='/finances/banks/add' layout={CompanyLayout} component={AddBankAccount} />

            <AppRoute exact path='/wallet' layout={CompanyLayout} component={Wallet} />
            <AppRoute exact path='/wallet/pay' layout={CompanyLayout} component={Pay} />
            <AppRoute exact path='/wallet/deposit/methods' layout={CompanyLayout} component={DepositMethods} />

            <AppRoute exact path='/cashless' layout={CompanyLayout} component={Cashless} />
            <AppRoute exact path='/cashless/economies/create' layout={CompanyLayout} component={CashlessEconomyCreate} />
            <AppRoute exact path='/cashless/economies/details/:uuid' layout={CompanyLayout} component={CashlessEconomyDetails} />



            
            {/**Para las rutas no encontradas */}
            <Route path="*">
                <Redirect path="/"/>
            </Route>
        </Switch>
    )
}